import React from 'react';
import { formatDate, formatCurrency } from '@/utils/format';
import type { ConstructionBoqVersion } from '../types/construction-boq.types';

interface BoqVersionTimelineProps {
  versions: ConstructionBoqVersion[];
}

export function BoqVersionTimeline({ versions }: BoqVersionTimelineProps) {
  if (!versions || versions.length === 0) return null;

  return (
    <div className="relative space-y-6 before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-200 before:to-transparent">
      {versions.map((v, idx) => (
        <div key={v.id} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active">
          {/* Dot */}
          <div className="flex items-center justify-center w-10 h-10 rounded-full border border-white bg-slate-50 shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 transition-colors group-hover:bg-os-primary group-hover:text-white group-hover:border-os-primary/20 duration-300">
            <span className="text-[10px] font-bold ">v{v.version_number}</span>
          </div>

          {/* Card */}
          <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-white p-4 rounded-2xl border border-slate-100 shadow-sm transition-all group-hover:shadow-md group-hover:border-os-primary/10 duration-300">
            <div className="flex items-center justify-between space-x-2 mb-1">
              <div className="font-bold text-slate-900">{v.version_name}</div>
              <time className="font-mono text-[10px] font-medium text-os-primary  bg-os-primary/5 px-2 py-0.5 rounded">
                {formatDate(v.created_at)}
              </time>
            </div>
            <div className="text-sm text-slate-500 mb-3">{v.description || 'Không có ghi chú cho phiên bản này.'}</div>
            <div className="flex items-center gap-4 pt-3 border-t border-slate-50">
              <div>
                <div className="text-[10px] font-bold text-slate-400  tracking-wider">Tổng giá trị</div>
                <div className="text-sm font-bold text-slate-900">{formatCurrency(v.total_amount)}</div>
              </div>
              <div className="h-8 w-px bg-slate-100" />
              <div>
                <div className="text-[10px] font-bold text-slate-400  tracking-wider">Trạng thái</div>
                <div className="text-sm font-bold text-emerald-600  tracking-tight">{v.status_code}</div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
